import { action } from 'easy-peasy';

export default {
  infoboxContent: null,
  setInfoboxContent: action((state, infoboxContent) => {
    state.infoboxContent = infoboxContent;
  })
};
